module.exports = __webpack_public_path__ + "img/node-js.bf23308e.svg";